package com.kaihuoy.components.common

import org.jetbrains.compose.web.css.*


object KaihuStyles : StyleSheet() {

    init {
        // Estetään vaakasuuntainen ylitäyttö mobiililla
        "html, body, #root" {
            property("max-width", "100vw")
            property("overflow-x", "hidden")
            property("box-sizing", "border-box")
        }

        // Tyylikäs scrollbar koko appiin
        "*::-webkit-scrollbar" {
            property("width", "6px")
            property("height", "6px")
        }
        "*::-webkit-scrollbar-track" {
            property("background", "transparent")
        }
        "*::-webkit-scrollbar-thumb" {
            property("background", "linear-gradient(135deg, #22d3ee 0%, #0891b2 100%)")
            property("border-radius", "555px")
        }
        "*::-webkit-scrollbar-thumb:hover" {
            property("background", "linear-gradient(135deg, #67e8f9 0%, #22d3ee 100%)")
        }

        ".kaihu-button" {
            property("transition", "all 0.25s ease")
        }

        ".kaihu-button:hover" {
            property("box-shadow", "0 8px 20px rgba(0, 0, 0, 0.15)")
            property("transform", "scale(1.04)")
        }

        ".kaihu-button:disabled" {
            cursor("not-allowed")
            opacity(0.6)
        }


        // --- PDF Tulostustyylit ---
        media("print") {
            "body" {
                backgroundColor(Color.white)
                margin(0.px)
                padding(0.px)
            }
            // Piilotetaan vain elementit joissa on .no-print luokka
            ".no-print" {
                display(DisplayStyle.None)
                property("display", "none !important")
            }
            // Piilotetaan elementit jotka on tarkoitettu vain DOC-vientiin tai webiin tulostuksessa
            ".only-doc, .no-print-doc" {
                display(DisplayStyle.None)
                property("display", "none !important")
            }
            // Varmistetaan että tulostettava osio on näkyvissä ja täyttää sivun
            ".print-container, #print-section" {
                display(DisplayStyle.Block)
                width(100.percent)
                property("height", "auto !important")
                property("overflow", "visible !important")
                property("min-height", "auto !important")
                property("max-height", "none !important")
                margin(0.px)
                padding(0.px)
                backgroundColor(Color.white)
                property("box-shadow", "none !important")
                property("border-radius", "0 !important")
                property("border", "none !important")
                // Pakotetaan näkyvyys jos se on muuten piilotettu
                property("visibility", "visible !important")
                property("display", "block !important")
                property("position", "relative !important")
                property("top", "0 !important")
                property("left", "0 !important")
                property("float", "none !important")
                property("transform", "none !important")
            }
            // Korjataan mahdolliset vanhemmat elementit jotka rajoittavat korkeutta
            "div, section, article, main" {
                property("height", "auto !important")
                property("max-height", "none !important")
                property("overflow", "visible !important")
                property("position", "static !important")
                property("display", "block !important")
                property("width", "100% !important")
                property("margin", "0 !important")
                property("padding", "0 !important")
                property("border", "none !important")
                property("box-shadow", "none !important")
                property("transform", "none !important")
                property("transition", "none !important")
            }
            // Varmistetaan että teksti on mustaa ja tausta valkoinen
            "h2, h3, p, span, div, label, td, th" {
                color(Color.black)
                backgroundColor(Color.transparent)
                property("box-shadow", "none")
                property("text-shadow", "none")
            }
            "h2" {
                marginBottom(12.pt)
                fontSize(18.pt)
            }
            "h3" {
                marginBottom(8.pt)
                marginTop(12.pt)
                fontSize(14.pt)
            }
            ".print-table" {
                width(100.percent)
                property("border-collapse", "collapse")
                marginBottom(16.pt)
            }
            ".print-table td, .print-table th" {
                border(1.pt, LineStyle.Solid, Color.black)
                padding(4.pt)
                fontSize(9.pt)
                property("vertical-align", "top")
            }
            ".print-table th" {
                backgroundColor(Color("#f0f0f0"))
                fontWeight("bold")
                textAlign("left")
            }
            ".checklist-grid" {
                display(DisplayStyle.Grid)
                gridTemplateColumns("1fr 1fr")
                gap(10.pt)
            }
            ".checklist-column" {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
            }
            ".checklist-row-print" {
                display(DisplayStyle.Flex)
                justifyContent(JustifyContent.SpaceBetween)
                property("border-bottom", "0.5pt solid black")
                padding(2.pt, 0.pt)
                fontSize(8.pt)
            }
            ".checklist-row-print.header" {
                fontWeight("bold")
                backgroundColor(Color("#f0f0f0"))
                property("border-bottom", "1pt solid black")
                marginTop(4.pt)
            }
            ".checklist-row-print .status" {
                width(60.pt)
                textAlign("right")
                fontWeight("bold")
            }
        }
    }
}

object AppStyles : StyleSheet() {

    val cardShadow by style {
        backgroundColor(Color.white)
        borderRadius(16.px)
        padding(24.px)
        property("box-shadow", "0 4px 12px rgba(0, 0, 0, 0.08)")

        "&:hover" {
            property("box-shadow", "0 8px 24px rgba(0, 0, 0, 0.12)")
            property("transition", "box-shadow 0.3s ease")
        }
    }

    // Lisää tämän funktioon tai globaalisti
    val hoverStyle by style {
        "&.hover-button:hover" {
            property("box-shadow", "0 8px 20px rgba(0, 0, 0, 0.15)")
            property("transform", "scale(1.03)")
        }
    }

    val styledButton by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        padding(14.px, 24.px)
        borderRadius(12.px)
        border(0.px)
        fontSize(1.05.em)
        fontWeight("600")
        cursor("pointer")
        property("transition","all 0.25s ease")
        property("box-shadow", "0 4px 12px rgba(0, 0, 0, 0.10)")

        // Hover-efekti
        "&:hover:not(:disabled)" {
            property("transform", "scale(1.04)")
            property("box-shadow", "0 8px 20px rgba(0, 0, 0, 0.15)")
        }

        // Disabled-tila
        "&:disabled" {
            cursor("not-allowed")
            opacity(0.6)
        }
    }

    // Uusi tyyli valitulle napille
    val selectedButton by style {
        backgroundColor(rgb(0, 170, 160))   // PrimaryTeal
        color(Color.white)
        property("box-shadow", "0 0 0 3px rgba(0, 170, 160, 0.3)")

        "&:hover" {
            backgroundColor(rgb(0, 150, 140))
        }
    }
}